import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import type { WorkerFilters } from "@/domains/workers/types";
import { useSalonStore } from "@/lib/store/salon";
import { TEAM_MEMBERS_QUERY } from "../graphql/team-members-query";

interface UseTeamMemberQueryProps {
  filters?: WorkerFilters;
}

export function useTeamMemberQuery(props: UseTeamMemberQueryProps = {}) {
  const { filters = {} } = props;
  const currentSalon = useSalonStore((state) => state.currentSalon);

  const queryResult = useQuery(TEAM_MEMBERS_QUERY, {
    variables: {
      salonId: currentSalon?.id || "",
      filters: filters
        ? {
            isActive: filters.isActive,
            search: filters.search,
          }
        : null,
    },
    skip: !currentSalon?.id,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
    returnPartialData: true,
    pollInterval: 60000,
  });

  const hasMore = useMemo(() => {
    return queryResult.data?.teamMembers?.pagination?.hasNext || false;
  }, [queryResult.data?.teamMembers?.pagination?.hasNext]);

  return {
    ...queryResult,
    data: queryResult.data,
    hasMore,
  };
}
